<template>
  <div class="admin-shell" :class="{ 'sidebar-collapsed': collapsed }">
    <aside class="admin-sidebar">
      <div class="admin-brand">
        <div class="brand-mark">优</div>
        <div v-show="!collapsed" class="brand-copy">
          <strong>优势探索</strong>
          <span>官网管理后台</span>
        </div>
      </div>

      <el-menu
        class="admin-menu"
        :default-active="$route.path"
        :collapse="collapsed"
        :collapse-transition="false"
        router
        background-color="transparent"
        text-color="#aebbd0"
        active-text-color="#ffffff"
      >
        <el-menu-item-group title="内容管理">
          <el-menu-item index="/admin/global-content">
            <i class="el-icon-monitor"></i><span slot="title">全站信息</span>
          </el-menu-item>
          <el-menu-item index="/admin/home-content">
            <i class="el-icon-house"></i><span slot="title">首页内容</span>
          </el-menu-item>
          <el-menu-item index="/admin/navigation-content">
            <i class="el-icon-guide"></i><span slot="title">团建导航</span>
          </el-menu-item>
          <el-submenu index="product-management">
            <template slot="title"><i class="el-icon-collection"></i><span>产品推荐</span></template>
            <el-menu-item index="/admin/case-content">页面设置</el-menu-item>
            <el-menu-item index="/admin/cases">推荐内容</el-menu-item>
          </el-submenu>
          <el-submenu index="service-management">
            <template slot="title"><i class="el-icon-news"></i><span>服务案例</span></template>
            <el-menu-item index="/admin/news-content">页面设置</el-menu-item>
            <el-menu-item index="/admin/news">案例内容</el-menu-item>
          </el-submenu>
          <el-menu-item index="/admin/about-content">
            <i class="el-icon-office-building"></i><span slot="title">优势探索</span>
          </el-menu-item>
          <el-menu-item index="/admin/contact-content">
            <i class="el-icon-phone-outline"></i><span slot="title">联系咨询</span>
          </el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="系统管理">
          <el-menu-item index="/admin/user">
            <i class="el-icon-user"></i><span slot="title">后台用户</span>
          </el-menu-item>
          <el-menu-item index="/admin/dictionary">
            <i class="el-icon-setting"></i><span slot="title">系统配置</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-menu>

      <div class="sidebar-footer">
        <span v-if="!collapsed">© {{ currentYear }} 优势探索</span>
        <small v-if="!collapsed">Advantages Exploring</small>
        <span v-else>©</span>
      </div>
    </aside>

    <section class="admin-workspace">
      <header class="admin-topbar">
        <div class="topbar-left">
          <button class="collapse-button" type="button" aria-label="切换侧边栏" @click="collapsed = !collapsed">
            <i :class="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </button>
          <div class="breadcrumb">
            <span>官网后台</span><i>/</i><strong>{{ currentMeta.title }}</strong>
          </div>
        </div>

        <div class="topbar-actions">
          <router-link class="site-link" to="/" target="_blank">
            <i class="el-icon-view"></i><span>查看官网</span>
          </router-link>
          <div class="admin-user-chip">
            <span class="user-avatar">AD</span>
            <span class="user-info"><strong>admin</strong><small>超级管理员</small></span>
          </div>
          <button class="logout-button" type="button" @click="logout">
            <i class="el-icon-switch-button"></i><span>退出</span>
          </button>
        </div>
      </header>

      <main class="admin-content">
        <div class="page-heading">
          <div>
            <div class="heading-row">
              <h1>{{ currentMeta.title }}</h1>
              <span>{{ currentMeta.tag }}</span>
            </div>
            <p>{{ currentMeta.description }}</p>
          </div>
          <span class="status-badge"><i></i> 系统运行正常</span>
        </div>

        <section class="admin-card">
          <router-view />
        </section>
      </main>

      <footer class="admin-footer">优势探索官网内容管理系统</footer>
    </section>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      collapsed: window.innerWidth < 900,
      pages: {
        "/admin/global-content": { title: "全站信息", tag: "GLOBAL", description: "维护网站 Logo、导航名称、页脚和备案信息" },
        "/admin/home-content": { title: "首页内容", tag: "HOME", description: "维护官网首页标题、按钮及核心介绍" },
        "/admin/navigation-content": { title: "团建导航", tag: "NAVIGATION", description: "维护团建导航页面的介绍与定制逻辑" },
        "/admin/case-content": { title: "产品推荐页面设置", tag: "PRODUCT PAGE", description: "维护产品推荐页面横幅与通用文字" },
        "/admin/news-content": { title: "服务案例页面设置", tag: "SERVICE PAGE", description: "维护服务案例页面横幅、分类名称与通用文字" },
        "/admin/news": { title: "服务案例", tag: "SERVICE", description: "发布和维护企业案例、活动案例与服务成果" },
        "/admin/cases": { title: "产品推荐", tag: "PRODUCT", description: "管理官网展示的团建产品与推荐内容" },
        "/admin/about-content": { title: "企业介绍", tag: "ABOUT", description: "维护优势探索品牌介绍和服务承诺" },
        "/admin/contact-content": { title: "联系咨询", tag: "CONTACT", description: "维护联系电话、微信和邮箱等咨询信息" },
        "/admin/team": { title: "团队风采", tag: "TEAM", description: "维护团队活动与企业风采图片" },
        "/admin/course": { title: "发展历程", tag: "HISTORY", description: "记录优势探索的重要发展节点" },
        "/admin/enterprise": { title: "合作企业", tag: "PARTNER", description: "管理合作企业名称与品牌标识" },
        "/admin/honor": { title: "资质荣誉", tag: "HONOR", description: "维护企业资质、奖项及荣誉资料" },
        "/admin/user": { title: "后台用户", tag: "ACCOUNT", description: "管理后台账号、状态与访问权限" },
        "/admin/dictionary": { title: "系统配置", tag: "SETTING", description: "维护官网系统参数和公共配置" }
      }
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    currentMeta() {
      return this.pages[this.$route.path] || { title: "内容管理", tag: "ADMIN", description: "优势探索官网内容管理后台" };
    }
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      this.$message({ message: "已安全退出后台", type: "success" });
      this.$router.replace("/login");
    }
  }
};
</script>

<style lang="scss">
.admin-shell {
  --admin-sidebar: 220px;
  min-height: 100vh;
  display: flex;
  color: #152238;
  background: #f2f5fa;
}
.admin-shell.sidebar-collapsed { --admin-sidebar: 72px; }

.admin-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 1100;
  width: var(--admin-sidebar);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(180deg, #101b31 0%, #0d172a 100%);
  box-shadow: 8px 0 28px rgba(27, 43, 74, .08);
  transition: width .22s ease;
}
.admin-brand {
  height: 70px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 11px;
  border-bottom: 1px solid rgba(255,255,255,.08);
}
.brand-mark {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  background: linear-gradient(135deg, #2f67eb, #6552db);
  box-shadow: 0 8px 20px rgba(47,103,235,.28);
}
.brand-copy { min-width: 0; display: flex; flex-direction: column; }
.brand-copy strong { color: #fff; font-size: 15px; white-space: nowrap; }
.brand-copy span { margin-top: 3px; color: #7f91ad; font-size: 11px; white-space: nowrap; }

.admin-menu { flex: 1; padding: 10px 8px; border-right: 0 !important; overflow-y: auto; overflow-x: hidden; }
.admin-menu:not(.el-menu--collapse) { width: 220px; }
.admin-menu.el-menu--collapse { width: 72px; }
.admin-menu .el-menu-item-group__title { padding: 17px 13px 8px !important; color: #63738d !important; font-size: 11px; letter-spacing: 1px; }
.admin-menu .el-menu-item {
  height: 44px;
  margin: 3px 0;
  padding: 0 13px !important;
  display: flex;
  align-items: center;
  border-radius: 8px;
  color: #aebbd0 !important;
  line-height: 44px;
  transition: background .2s, color .2s;
}
.admin-menu .el-menu-item i { width: 22px; margin-right: 10px; color: #8290a8; font-size: 17px; }
.admin-menu .el-menu-item:hover { color: #fff !important; background: rgba(255,255,255,.07) !important; }
.admin-menu .el-menu-item.is-active { color: #fff !important; font-weight: 600; background: linear-gradient(100deg, rgba(47,103,235,.88), rgba(82,78,207,.78)) !important; box-shadow: 0 8px 18px rgba(29,72,174,.22); }
.admin-menu .el-menu-item.is-active i { color: #fff; }
.admin-menu.el-menu--collapse .el-menu-item { justify-content: center; padding: 0 !important; }
.admin-menu.el-menu--collapse .el-menu-item i { width: auto; margin: 0; }
.admin-menu.el-menu--collapse .el-menu-item-group__title { height: 13px; padding: 0 !important; overflow: hidden; font-size: 0; }
.sidebar-footer { min-height: 68px; padding: 14px 16px; display: flex; flex-direction: column; justify-content: center; color: #71819b; font-size: 11px; border-top: 1px solid rgba(255,255,255,.08); }
.sidebar-footer small { margin-top: 4px; color: #4f607a; }

.admin-workspace { width: calc(100% - var(--admin-sidebar)); min-height: 100vh; margin-left: var(--admin-sidebar); display: flex; flex-direction: column; transition: width .22s ease, margin-left .22s ease; }
.admin-topbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  height: 70px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255,255,255,.96);
  border-bottom: 1px solid #e1e7f0;
  backdrop-filter: blur(12px);
}
.topbar-left, .topbar-actions { display: flex; align-items: center; }
.topbar-left { gap: 17px; }
.collapse-button, .logout-button {
  border: 1px solid #dce4ef;
  border-radius: 8px;
  color: #40506a;
  background: #fff;
  cursor: pointer;
  transition: border-color .2s, color .2s, background .2s;
}
.collapse-button { width: 42px; height: 38px; font-size: 18px; }
.collapse-button:hover, .logout-button:hover { color: #2563eb; border-color: #a9bee9; background: #f5f8ff; }
.breadcrumb { display: flex; align-items: center; gap: 9px; color: #8a97aa; font-size: 13px; }
.breadcrumb i { color: #c0c9d7; font-style: normal; }.breadcrumb strong { color: #3b4b64; font-weight: 500; }
.topbar-actions { gap: 12px; }
.site-link { height: 38px; padding: 0 13px; display: inline-flex; align-items: center; gap: 7px; border: 1px solid #dce4ef; border-radius: 8px; color: #51617a; font-size: 13px; text-decoration: none; background: #fff; }
.site-link:hover { color: #2563eb; border-color: #a9bee9; }
.admin-user-chip { height: 42px; padding: 4px 12px 4px 5px; display: flex; align-items: center; gap: 8px; border: 1px solid #dfe6f0; border-radius: 22px; background: #f8faff; }
.user-avatar { width: 32px; height: 32px; display: grid; place-items: center; border-radius: 50%; color: #fff; font-size: 11px; font-weight: 700; background: #2867e8; }
.user-info { display: flex; flex-direction: column; }.user-info strong { color: #28364c; font-size: 12px; }.user-info small { margin-top: 2px; color: #91a0b5; font-size: 10px; }
.logout-button { height: 38px; padding: 0 13px; display: flex; align-items: center; gap: 7px; }

.admin-content { flex: 1; width: 100%; max-width: 1600px; margin: 0 auto; padding: 30px 24px 38px; }
.page-heading { margin-bottom: 22px; display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; }
.heading-row { display: flex; align-items: center; gap: 10px; }.heading-row h1 { color: #132038; font-size: 25px; line-height: 1.3; }.heading-row span { padding: 4px 8px; border: 1px solid #cfe0ff; border-radius: 12px; color: #2563eb; font-size: 10px; font-weight: 700; background: #edf4ff; }
.page-heading p { margin-top: 8px; color: #718098; font-size: 13px; }
.status-badge { padding: 7px 11px; display: inline-flex; align-items: center; gap: 7px; border: 1px solid #d6eee4; border-radius: 16px; color: #348267; font-size: 11px; background: #f0faf6; }.status-badge i { width: 7px; height: 7px; border-radius: 50%; background: #28a574; box-shadow: 0 0 0 3px rgba(40,165,116,.12); }
.admin-card { min-height: 320px; padding: 22px; border: 1px solid #dfe6ef; border-radius: 13px; background: #fff; box-shadow: 0 2px 4px rgba(26,43,73,.04), 0 14px 38px rgba(26,43,73,.035); }
.admin-footer { padding: 16px 24px 22px; color: #94a0b2; text-align: center; font-size: 12px; }

/* Unified Element UI treatment inside the legacy content pages */
.admin-card > div > .el-button:first-child { margin-bottom: 2px; }
.admin-card .el-button { border-radius: 7px; transition: transform .15s, box-shadow .15s, border-color .15s; }
.admin-card .el-button--primary { border-color: #2f67e9; background: #2f67e9; }
.admin-card .el-button--primary:hover { border-color: #245bd5; background: #245bd5; box-shadow: 0 6px 14px rgba(47,103,233,.2); }
.admin-card .el-button--danger { border-color: #e65d65; background: #e65d65; }
.admin-card .el-table { margin-top: 20px !important; border: 1px solid #e3e9f1 !important; border-radius: 10px; overflow: hidden; color: #3c4a60; }
.admin-card .el-table::before, .admin-card .el-table--border::after { display: none; }
.admin-card .el-table th { height: 48px; color: #45546b; font-weight: 600; background: #f6f8fc !important; }
.admin-card .el-table td { padding: 11px 0; border-color: #edf0f5; }
.admin-card .el-table tr:hover > td { background: #f8faff !important; }
.admin-card .el-table img { width: auto !important; max-width: 120px !important; height: auto; max-height: 78px; border-radius: 7px; object-fit: cover; }
.admin-card .el-input__inner, .admin-card .el-textarea__inner { border-color: #dbe3ee; border-radius: 8px; }
.admin-card .el-input__inner:focus, .admin-card .el-textarea__inner:focus { border-color: #2f67e9; box-shadow: 0 0 0 3px rgba(47,103,233,.1); }
.el-dialog { max-width: calc(100vw - 32px); border-radius: 14px; overflow: hidden; box-shadow: 0 30px 80px rgba(18,32,58,.24); }
.el-dialog__header { padding: 20px 24px; border-bottom: 1px solid #e6ebf2; }.el-dialog__title { color: #1c2b43; font-size: 18px; font-weight: 700; }.el-dialog__body { padding: 26px 30px; }.el-dialog__footer { padding: 16px 24px; border-top: 1px solid #e6ebf2; background: #fafbfc; }
.avatar-uploader .el-upload { border: 1px dashed #b9c6d8; border-radius: 9px; cursor: pointer; position: relative; overflow: hidden; background: #f8faff; }
.avatar-uploader .el-upload:hover { border-color: #2f67e9; }
.avatar-uploader-icon { width: 160px; height: 140px; color: #8291a8; font-size: 27px; line-height: 140px; text-align: center; }
.avatar { width: 160px; height: 140px; display: block; object-fit: cover; }

@media (max-width: 760px) {
  .admin-shell { --admin-sidebar: 64px; }
  .admin-sidebar { width: 64px; }
  .admin-brand { padding: 0 13px; }.brand-mark { width: 38px; }
  .admin-menu.el-menu--collapse { width: 64px; padding-left: 6px; padding-right: 6px; }
  .admin-workspace { width: calc(100% - 64px); margin-left: 64px; }
  .admin-topbar { height: auto; min-height: 64px; padding: 10px 14px; }
  .breadcrumb span, .breadcrumb i, .site-link span, .user-info, .logout-button span { display: none; }
  .topbar-actions { gap: 7px; }.site-link, .logout-button { width: 38px; padding: 0; justify-content: center; }.admin-user-chip { padding-right: 5px; }
  .admin-content { padding: 22px 14px 30px; }.page-heading { align-items: flex-start; }.status-badge { display: none; }.heading-row h1 { font-size: 22px; }.admin-card { padding: 14px; overflow-x: auto; }
  .el-dialog { width: calc(100vw - 28px) !important; margin-top: 4vh !important; }.el-dialog__body { padding: 20px 16px; }
}

@media (prefers-reduced-motion: reduce) {
  .admin-sidebar, .admin-workspace, .admin-menu .el-menu-item, .admin-card .el-button { transition: none !important; }
}
</style>
